import AssessmentIcon from '@material-ui/icons/Assessment'
import List from './List'


export default {
  list: List,
  icon: AssessmentIcon,
}
